<template>
    <div class="marketing-configure-page">
        <preloader :display="isLoading" class="marketing-configure-page__loader" />

        <div class="marketing-configure-page__header">
            <div class="marketing-configure-page__header-logo" @click="goToUrl('/home')">
                <CompassLogo type="logo" :width="100" />
            </div>
        </div>

        <div class="marketing-configure-page__content">
            <div class="marketing-configure-page__content-title typographies-display-medium">
                {{ $l10n.__('Synchronisation de vos données') }}
            </div>

            <div
                class="marketing-configure-page__content-informations typographies-paragraph-medium-regular"
            >
                {{ $l10n.__('En cliquant sur "Synchroniser" :') }}
                <ul>
                    <li>
                        {{
                            $l10n.__(
                                'Une synchronisation automatique de certains champs utilisés dans vos autres modules se déclenchera. Vous aurez par la suite la possibilité de synchroniser d’autres champs depuis vos réglages Sellsy.',
                            )
                        }}
                    </li>
                    <li>
                        {{
                            $l10n.__(
                                'Tous vos contacts liés à une société (ou un particulier) seront synchronisés. Vous les retrouverez dans votre module marketing, et ils se mettront à jour quotidiennement.',
                            )
                        }}
                    </li>
                </ul>
                {{
                    $l10n.__(
                        'Notez que chaque collaborateur ayant accès au module marketing aura connaissance de tous les contacts synchronisés.',
                    )
                }}
            </div>

            <div class="marketing-configure-page__content-buttons">
                <CompassButton
                    :label="$t.__('common.actions.synchronise')"
                    size="large"
                    @click="configureAccount"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import marketingService from 'api/marketing/marketingService.js';

export default {
    components: { Preloader },
    data() {
        return {
            isLoading: false,
        };
    },
    methods: {
        goToUrl,
        configureAccount() {
            this.isLoading = true;
            marketingService
                .configureAccount()
                .then((response) => {
                    goToUrl(response.location);
                })
                .catch((error) => {
                    goToUrl(error.responseJSON.location);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.marketing-configure-page {
    display: flex;
    flex-direction: column;
    align-items: center;

    &__header {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 0 var(--spacing-6);
        margin-bottom: var(--spacing-7);

        &-logo {
            cursor: pointer;
        }
    }

    &__content {
        width: 648px;
        padding: 0 var(--spacing-6);

        &-title {
            margin-bottom: var(--spacing-4);
        }

        &-informations {
            ul {
                list-style-type: disc;
                padding-left: var(--spacing-4);
            }
        }

        &-buttons {
            margin-top: var(--spacing-6);
        }
    }
}
</style>
